import Button from "../ui/button";
export default function CardErrorModal({ isOpen, error, onClose }) {
  if (!isOpen) return null;
  // add switch case to handle different error messages
  switch (error) {
    case "card_declined":
      error = "Card Declined!";
      break;
    case "insufficient_funds":
      error = "Insufficient Funds!";
      break;
    case "expired_card":
      error = "Expired Card!";
      break;
    case "UNEXPECTED_SDK_ERROR":
      error = "The card reader had a temporary issue!";
    default:
      error = "Card Declined!"
  }
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Back button to close the modal */}
      <div
        className="absolute inset-0 bg-black bg-opacity-80"
        onClick={onClose} />

      {/* Modal */}
      <div className="relative bg-white w-full max-w-2xl mx-4 overflow-hidden min-h-[500px] flex flex-col rounded-[15px]">
        {/* Header */}
        {/* <div className="bg-white px-6 py-6 mb-5 flex items-center justify-between">
          <button
            onClick={onClose}
            className="w-12 h-12 flex items-center justify-center text-white rounded-xl transition-colors"
          >
            <img
              src="/images/back.png"
              alt="back"
              className="w-[50px] h-[50px] rounded-[12px]"
            />
          </button>
        </div> */}
        {/* error instructions */}
        <div className="bg-paymentbg px-10 pt-10 pb-12 text-center flex-grow flex flex-col items-center justify-center">
          <div className="flex justify-center mb-10">
            <img src="/images/error.png" alt="error" className="w-[80px] h-[80px]" />
          </div>
          <p className="lg:text-[45px] text-[24px] font-outfit font-semibold text-boonsdarkbg leading-relaxed">
            {error}
          </p>
        </div>

        {/* Footer Button */}
        <Button
          variant="orange"
          size="home"
          className="w-full h-[140px] lg:text-[45px] text-[24px] font-outfit font-semibold rounded-none border-none"
          onClick={() => {
            onClose();
          }}
        >
          Try Again
        </Button>
      </div>
    </div>
  );
};
